// Utility functions for user data formatting
import { formatUserRole as formatRole } from '../constants/roles';

export interface UserProfile {
  id: string;
  username?: string;
  email?: string;
  name?: string;
  lastLogin?: string;
  role?: string;
}

/**
 * Get the display name for a user (prefer name, fallback to username)
 */
export const getUserDisplayName = (user: UserProfile): string => {
  return user?.name?.trim()  ||'-' ;
};

/**
 * Get the user identifier (prefer email, fallback to @username)
 */
export const getUserIdentifier = (user: UserProfile): string => {
  return user.email || '-';
};

/**
 * Format last login time in a human-readable format
 */
export const formatLastLogin = (lastLogin?: string): string => {
  if (!lastLogin) return 'Never';
  
  const date = new Date(lastLogin);
  const now = new Date();
  const diffInHours = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60));
  
  if (diffInHours < 1) return 'Just now';
  if (diffInHours < 24) return `${diffInHours}h ago`;
  if (diffInHours < 48) return 'Yesterday';
  
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric',
    year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined 
  });
};

/**
 * Get user initials for avatar display
 */
export const getUserInitials = (user: UserProfile): string => {
  const name = getUserDisplayName(user);
  const words = name.split(' ');
  
  if (words.length >= 2) {
    return `${words[0][0]}${words[1][0]}`.toUpperCase();
  }
  
  return name.substring(0, 2).toUpperCase();
};

/**
 * Format user role for display
 * @deprecated - Use formatUserRole from '../constants/roles' directly
 */
export const formatUserRole = formatRole;

const userUtils = {
  getUserDisplayName,
  getUserIdentifier,
  formatLastLogin,
  getUserInitials,
  formatUserRole,
};

export default userUtils; 